import axios from "axios";
import { getToken, getTokenMicro } from "../../../config/getToken";
import { env } from "../../../env";
import { convertFileToBase64 } from "../../../utils/functions";
import { CODES } from "../../../consts/codes";

//TODO: ajustar el objeto data con los nuevos atributos donde se haga el llamado a GetMasters, el axios ya esta ajustado
/** Obtiene el listado de maestros cargados de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de maestros. */
export async function GetMasters(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/uploads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Lista los maestros descargados de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de descargas. */
export async function ListDownloadMaster(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();
  return axios({
    method: "POST",
    url: `masters/downloads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Obtiene la plantilla de un maestro.
 * @param {Object} data - Datos con el tipo de maestro.
 * @returns {Promise<*>} Plantilla codificada. */
export async function GetMastersTemplate(data) {
  const token = await getTokenMicro();
  const { master } = data;
  const route =
    master === "0" ? "budget" : master === "3" ? "pointssalesreferences" : "productsreferences";
  return axios({
    method: "GET",
    url: `masters/downloads/${route}/templates`,
    baseURL: env.REACT_APP_API_URL_MASTERFILES,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene la guía de un maestro.
 * @param {Object} data - Datos con el tipo de maestro.
 * @returns {Promise<*>} Guía codificada. */
export async function GetMastersGuide(data) {
  const token = await getTokenMicro();
  const { master } = data;
  const route =
    master === "0" ? "budget" : master === "3" ? "pointssalesreferences" : "productsreferences";
  return axios({
    method: "GET",
    url: `masters/downloads/${route}/guides`,
    baseURL: env.REACT_APP_API_URL_MASTERFILES,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Sube un archivo de maestro al sistema.
 * @param {Object} data - Datos del archivo a subir.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function UploadMastersFile(data) {
  const tokenMicro = await getTokenMicro();

  const { master, obj } = data;
  const route =
    master === "0"
      ? "budgetseller"
      : master === "3"
        ? "pointssalesreferences"
        : "productsreferences";
  const idFile =
    master === "0" ? CODES.BUDGETS : master === "3" ? CODES.SALEPOINT : CODES.PRODUCTSREFERENCES;
  const formData = new FormData();
  formData.append("file", obj.file);

  //Codificacion del archivo subido
  const finalData = await convertFileToBase64(formData, idFile, obj);

  return axios({
    method: "POST",
    url: `masters/uploads/${route}`,
    data: finalData,
    baseURL: env.REACT_APP_API_URL_MASTERFILES,
    validateStatus: null,
    headers: {
      Authorization: tokenMicro,
    },
  });
}

/**
 * Función que permite subir el archivo de catalogos al sistema
 * @param data Archivo a subir
 */
export async function UploadCatalog(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();
  const formData = new FormData();

  formData.append("file", data.file);

  const finalData = await convertFileToBase64(formData, CODES.CATALOG, data);

  return axios({
    method: "POST",
    url: "masters/uploads/catalogs",
    data: finalData,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/** Descarga un archivo de maestro.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadMastersFile(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga el log de errores de maestro.
 * @param {Object} data - Datos del log a descargar.
 * @returns {Promise<*>} Log de errores. */
export async function DownloadMastersErrorLog(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads/logs`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de maestro desde la tabla.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadMasterFromTable(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `masters/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de presupuesto.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadMastersBudget(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `budget/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de referencias de productos.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadMastersProductsReferences(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: `productsreferences/downloads`,
    baseURL: env.REACT_APP_API_URL,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga un archivo de referencias de punto de venta.
 * @param {Object} data - Datos de descarga.
 * @returns {Promise<*>} Archivo descargado. */
export async function DownloadMastersPointOfSaleReferences(data) {
  const token = await getTokenMicro();
  return axios({
    method: "POST",
    url: `pointssalesreferences`,
    baseURL: env.REACT_APP_API_URL_POINTOFSALE,
    data: data,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
